// components/TruckerNavbar.js

import React, { useContext, useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { UserContext } from '../context/UserContext'
import api from '../services/api'

function TruckerNavbar() {
  const { userData, logout } = useContext(UserContext)
  const navigate = useNavigate()
  const [unreadCount, setUnreadCount] = useState(0)
  const [menuOpen, setMenuOpen] = useState(false)

  const handleLogout = () => {
    logout()
    navigate('/')
  }

  useEffect(() => {
    if (userData) {
      loadUnread()
    }
  }, [userData])

  const loadUnread = async () => {
    const res = await api.get('/session/company-sessions')
    let total = 0
    res.data.sessions.forEach(s => {
      total += s.messages.filter(m => m.sender === 'guest').length
    })
    setUnreadCount(total)
  }

  const toggleMenu = () => {
    setMenuOpen(!menuOpen)
  }

  return (
    <nav className="navbar">
      <div className="navbar-brand">R2D2+</div>
	       <li className="language-selector-wrapper">
              <div id="language-selector-container" className="language-selector-container" />
            </li>

    </nav>
  )
}

export default TruckerNavbar